import React from 'react';

import styles from './QCDSummaries.module.scss';
import {useDispatch, useSelector} from "react-redux";
import { getAllQCDHistory } from "../../../../redux/modules/qcdHistory/QCDHistory.selector";
import {QCDGetPDF} from "../../../../redux/modules/qcdHistory/QCDHistory.module";

export const QCDSummaries = ({ onClose }) => {
  const qcdHistory = useSelector(getAllQCDHistory);
  const dispatch = useDispatch();
  return <div>
    <div className={styles['header']}>QCD Summaries</div>
    <div className={styles['details']}>
      Here are the previous 7 years of Qualified Charitable Distributions
      you've requested online. You can review the amount, receiving charity,
      and other key details.
    </div>
    <div className={styles['summaryList']}>
      {qcdHistory?.sort((a, b) => b.qcdID - a.qcdID).map((qcd) =>
        <div key={qcd.qcdID} className={styles['qcd-summary-container']}>
          <button
            className={styles['qcdSummary']}
            onClick={() => {
              dispatch(QCDGetPDF(qcd.qcdID, qcd.displayName));
            }}
          >
            {qcd.displayName}
          </button>
        </div>
      )}
    </div>
  </div>
}